export class Grade {
  id: number;
  libelle: string;
  etat: boolean;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/grade.ts